module.exports = __webpack_public_path__ + "img/vignettes-asso_0008_street-art-13.cb4e423b.jpg";